import React from 'react';
// styles
import styled from 'styled-components';

const ShipmentDownloadIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Shipment Download"
    className={className}
  >
    <path
      d="M11.4124 6.9165C11.4946 6.89447 11.5517 6.82007 11.5519 6.735V4.125C11.5519 4.02145 11.4679 3.9375 11.3644 3.9375H0.691896C0.642107 3.9373 0.594299 3.95699 0.559092 3.9922C0.523886 4.0274 0.504196 4.07521 0.504396 4.125V10.7498C0.504396 11.3596 0.998552 11.8541 1.6084 11.8545H6.71365C6.80286 11.8548 6.87984 11.792 6.8974 11.7045C7.37686 9.38363 9.12363 7.53124 11.4124 6.9165Z"
      fill="#FCC475"
    />
    <path
      d="M6.58008 2.6445C6.58008 2.74805 6.66403 2.832 6.76758 2.832H10.6983C10.7743 2.83213 10.8428 2.78645 10.8719 2.7163C10.901 2.64614 10.8848 2.56538 10.8311 2.51175L8.71308 0.393747C8.50549 0.187482 8.22497 0.0713405 7.93233 0.0704971H6.76758C6.71779 0.0702968 6.66998 0.0899868 6.63478 0.125193C6.59957 0.1604 6.57988 0.208208 6.58008 0.257997V2.6445Z"
      fill="#FCC475"
    />
    <path
      d="M5.28801 2.832C5.39156 2.832 5.47551 2.74805 5.47551 2.6445V0.257997C5.47571 0.208208 5.45602 0.1604 5.42081 0.125193C5.3856 0.0899868 5.3378 0.0702968 5.28801 0.0704971H4.12326C3.83042 0.0714668 3.54972 0.187574 3.34176 0.393747L1.22526 2.51175C1.17149 2.56538 1.15538 2.64614 1.18446 2.7163C1.21354 2.78645 1.28207 2.83213 1.35801 2.832H5.28801Z"
      fill="#FCC475"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.05396 12.9585C8.05396 10.2131 10.2795 7.98749 13.025 7.98749C15.769 7.99079 17.9926 10.2145 17.996 12.9585C17.996 15.7039 15.7704 17.9295 13.025 17.9295C10.2795 17.9295 8.05396 15.7039 8.05396 12.9585ZM10.9243 13.1663C10.8628 13.2943 10.8803 13.4463 10.9692 13.557L12.7377 15.7665C12.8077 15.8536 12.9135 15.9043 13.0253 15.9043C13.1371 15.9043 13.2429 15.8536 13.313 15.7665L15.0807 13.557C15.1696 13.4463 15.1871 13.2943 15.1256 13.1663C15.0642 13.0383 14.9347 12.9569 14.7927 12.957H13.9482C13.8447 12.957 13.7607 12.873 13.7607 12.7695V10.7445C13.7607 10.3377 13.431 10.008 13.0242 10.008C12.6174 10.008 12.2877 10.3377 12.2877 10.7445V12.7695C12.2877 12.873 12.2038 12.957 12.1002 12.957H11.2572C11.1152 12.9569 10.9857 13.0383 10.9243 13.1663Z"
      fill="#FCC475"
    />
  </svg>
);

export default styled(ShipmentDownloadIcon)``;
